import { SxProps } from "@mui/material";
import React from "react";
import { Control } from "react-hook-form";
import { UseFormSelect } from "./UseFormSelect";

interface UseFormSelectCatalystProps {
  control: Control
  name: string
  sx: SxProps
}

export const UseFormSelectCatalyst: React.FC<UseFormSelectCatalystProps> = ({
  control,
  name,
  sx = {}
}) => {
  return (
    <UseFormSelect
      control={control}
      name={name}
      items={[
        {value: '', label: ''},
        {value: true, label: 'With Catalyst'},
        {value: false, label: 'Without Catalyst'},
      ]}
      sx={{
        width: '200px',
        ...sx,
      }}
    />
  )
}